export default "__VITE_ASSET__CAlPFDJ7__"